var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-wrapper"},[_c('div',{staticClass:"content"},[_c('v-row',{staticClass:"ma-0"},[_c('router-link',{staticClass:"mx-3 my-2",attrs:{"to":"/admin/pendingConnectors"}},[_vm._v("Подключение коннекторов")])],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }